var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * 
 * @file Helper for the open_with_integrations API endpoint
 * @author Box
 */

import Base from './Base';
import { HEADER_ACCEPT_LANGUAGE, DEFAULT_LOCALE } from '../constants';

var OpenWith = function (_Base) {
    _inherits(OpenWith, _Base);

    function OpenWith() {
        _classCallCheck(this, OpenWith);

        return _possibleConstructorReturn(this, (OpenWith.__proto__ || Object.getPrototypeOf(OpenWith)).apply(this, arguments));
    }

    _createClass(OpenWith, [{
        key: 'getUrl',

        /**
         * API URL for Open With
         *
         * @param {string} [id] - a box file id
         * @return {string} base url for files
         */
        value: function getUrl(id) {
            if (!id) {
                throw new Error('Missing file id!');
            }

            return this.getBaseApiUrl() + '/files/' + id + '/open_with_integrations';
        }

        /**
         * Gets Open With integration data
         *
         * @param {string} fileId - Box file ID
         * @param {string} locale - locale to receive translated strings from the API
         * @param {Function} successCallback - Success callback
         * @param {Function} errorCallback - Error callback
         * @return {void}
         */

    }, {
        key: 'getOpenWithIntegrations',
        value: function getOpenWithIntegrations(fileId) {
            var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_LOCALE;

            var _this2 = this;

            var _successCallback = arguments[2];
            var errorCallback = arguments[3];

            var params = {
                headers: _defineProperty({}, HEADER_ACCEPT_LANGUAGE, locale)
            };

            this.get({
                id: fileId,
                params: params,
                successCallback: function successCallback(openWithIntegrations) {
                    var formattedOpenWithData = _this2.formatOpenWithData(openWithIntegrations);
                    _successCallback(formattedOpenWithData);
                },
                errorCallback: errorCallback
            });
        }

        /**
         * Formats Open With data conveniently for the client
         *
         * @param {Array<Object>} openWithIntegrations - The modified Open With integration objects
         * @return {Array<Integration>} formatted Open With integrations
         */

    }, {
        key: 'formatOpenWithData',
        value: function formatOpenWithData(openWithIntegrations) {
            var items = openWithIntegrations.items,
                defaultIntegration = openWithIntegrations.default_app_integration;

            var integrations = items.map(function (_ref) {
                var app_integration = _ref.app_integration,
                    disabled_reasons = _ref.disabled_reasons,
                    display_name = _ref.display_name,
                    display_description = _ref.display_description,
                    display_order = _ref.display_order,
                    is_disabled = _ref.is_disabled,
                    should_show_consent_popup = _ref.should_show_consent_popup;
                var id = app_integration.id,
                    type = app_integration.type;


                return {
                    appIntegrationId: id,
                    displayDescription: display_description,
                    disabledReasons: disabled_reasons,
                    displayOrder: display_order,
                    isDefault: !!defaultIntegration && id === defaultIntegration.id,
                    isDisabled: is_disabled,
                    displayName: display_name,
                    requiresConsent: should_show_consent_popup,
                    type: type
                };
            });

            // Sort integrations by displayOrder
            return integrations.sort(function (integrationA, integrationB) {
                return integrationA.displayOrder - integrationB.displayOrder;
            });
        }
    }]);

    return OpenWith;
}(Base);

export default OpenWith;